/* Keep the tiny background until the real image can be painted. Full images
 * retain their native src/srcset/loading behavior; this never gates a request.
 * One delegated listener also covers gallery/variant and Theme Editor inserts. */
(() => {
  if (window.rtaImageLoading) return;
  window.rtaImageLoading = true;

  const selector = 'img.rta-image-lqip';
  const pending = new WeakMap();
  const retire = (image) => {
    if (!image.matches?.(selector) || !image.complete || !image.naturalWidth) return;
    const source = image.currentSrc || image.src;
    if (image.hasAttribute('data-rta-lqip-ready') || pending.get(image) === source) return;
    pending.set(image, source);
    const decoded = image.decode ? image.decode() : Promise.resolve();
    decoded.then(() => {
      if (pending.get(image) !== source) return;
      pending.delete(image);
      if (image.isConnected && image.complete && image.naturalWidth && (image.currentSrc || image.src) === source) {
        image.setAttribute('data-rta-lqip-ready', '');
      }
    }, () => {
      // A decode failure must not remove the only reliable image still shown.
      if (pending.get(image) === source) pending.delete(image);
    });
  };
  const scan = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) retire(node);
    node.querySelectorAll(selector).forEach(retire);
  };

  document.addEventListener('load', (event) => retire(event.target), true);
  scan(document.documentElement);
  new MutationObserver((records) => {
    for (const record of records) record.addedNodes.forEach(scan);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
